import React, { useState } from 'react';
import { 
  AppBar, 
  Toolbar, 
  Typography, 
  Button, 
  Container, 
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Divider,
  useMediaQuery,
  useTheme,
  Menu,
  MenuItem,
  Fade,
  Paper
} from '@mui/material';
import { Link } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import logo from '../assets/images/shooralogo.png'; // Import the logo
 // Replace with the actual path to your logo
const pages = [
  { name: 'Home', path: '/' },
  { name: 'Services', path: '/services' },
  { name: 'About', path: '/about' },
  { name: 'Contact', path: '/contact' },
  { name: 'Careers', path: '/careers' }
];

// Updated header for microfinance branding
const Header = () => {
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);
  const [mobileSubmenuOpen, setMobileSubmenuOpen] = useState(false);
  const [aboutAnchorEl, setAboutAnchorEl] = useState(null);
  
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const handleAboutClick = (event) => {
    setAboutAnchorEl(event.currentTarget);
  };

  const handleAboutClose = () => {
    setAboutAnchorEl(null);
  };

  const toggleMobileDrawer = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const toggleMobileSubmenu = () => {
    setMobileSubmenuOpen(!mobileSubmenuOpen);
  };

  const handleMobileMenuClick = () => {
    setMobileDrawerOpen(false);
  };

  const mobileNavItems = [
    { text: 'Home', link: '/' },
    { text: 'Services', link: '/services' },
    { text: 'Contact', link: '/contact' },
    { text: 'Apply for Loan', link: '/apply' }
  ];

  const aboutSubmenuItems = [
    { text: 'About Us', link: '/about' },
    { text: 'Our Vision & Mission', link: '/vision-mission' },
    { text: 'Our Methodology', link: '/methodology' },
    { text: 'Our Partners', link: '/partners' }
  ];

  return (
    <>
      <AppBar position="static" sx={{ bgcolor: 'secondary.main', boxShadow: 'none' }}>
        <Container>
          <Toolbar sx={{ display: 'flex', justifyContent: 'space-between', padding: '1rem 0' }}>
            <Box 
              component={Link} 
              to="/" 
              sx={{ 
                textDecoration: 'none', 
                color: 'inherit',
                display: 'flex',
                alignItems: 'center',
                gap: 1.5
              }}
            >
              <Box
                component="img"
                src={logo} // Use the imported logo
                alt="Logo"
                sx={{
                  width: 50,
                  height: 50,
                  borderRadius: '50%',
                  backgroundColor: 'white',
                  padding: 0.5,
                  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                }}
              />
              <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 'bold',
                    fontFamily: 'Roboto, sans-serif',
                    letterSpacing: '0.05em',
                    fontSize: { xs: '1.2rem', sm: '1.5rem' },
                    lineHeight: 1.2
                  }}
                >
                  SHOORA WELFARE
                </Typography>
                <Typography 
                  variant="subtitle2" 
                  sx={{ 
                    fontFamily: 'Roboto, sans-serif',
                    fontSize: { xs: '0.8rem', sm: '1rem' },
                    color: 'text.secondary',
                    lineHeight: 1.2
                  }}
                >
                  FOUNDATION
                </Typography>
              </Box>
            </Box>

            {isMobile ? (
              <IconButton
                edge="end"
                color="inherit"
                aria-label="menu"
                onClick={toggleMobileDrawer}
              >
                <MenuIcon />
              </IconButton>
            ) : (
              <Box sx={{ display: 'flex', gap: 2.5 }}> {/* Adjusted gap for better spacing */}
                <Button color="inherit" component={Link} to="/" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Home
                </Button>
                <Button color="inherit" component={Link} to="/services" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Services
                </Button>
                <Button 
                  color="inherit" 
                  onClick={handleAboutClick}
                  sx={{ 
                    fontWeight: 'bold', 
                    fontSize: '0.9rem', 
                    display: 'flex',
                    alignItems: 'center',
                    gap: 0.5
                  }}
                >
                  About
                  <KeyboardArrowDownIcon />
                </Button>
                <Menu
                  anchorEl={aboutAnchorEl}
                  open={Boolean(aboutAnchorEl)}
                  onClose={handleAboutClose}
                  TransitionComponent={Fade}
                  anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                  }}
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                  }}
                  PaperProps={{
                    elevation: 3,
                    sx: {
                      mt: 1.5,
                      minWidth: 180,
                      borderRadius: 2,
                      '& .MuiList-root': {
                        py: 1
                      }
                    }
                  }}
                >
                  {aboutSubmenuItems.map((item) => (
                    <MenuItem
                      key={item.text}
                      onClick={handleAboutClose}
                      component={Link}
                      to={item.link}
                      sx={{
                        py: 1.5,
                        px: 2.5,
                        '&:hover': {
                          bgcolor: 'rgba(0, 0, 0, 0.04)'
                        }
                      }}
                    >
                      {item.text}
                    </MenuItem>
                  ))}
                </Menu>
                <Button color="inherit" component={Link} to="/contact" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Contact
                </Button>
                <Button color="inherit" component={Link} to="/careers" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Career
                </Button>
                
                <Button color="inherit" component={Link} to="/donation" sx={{ fontWeight: 'bold', fontSize: '0.9rem' }}>
                  Donate
                </Button>
                <Button 
                  variant="contained" 
                  color="primary"
                  component={Link} 
                  to="/apply" 
                  sx={{ 
                    fontWeight: 'bold', 
                    fontSize: '0.9rem',
                    px: 2.5,
                    backgroundColor: 'primary.main',
                    '&:hover': {
                      backgroundColor: 'primary.dark',
                    }
                  }}
                >
                  Apply for Loan
                </Button>
              </Box>
            )}
          </Toolbar>
        </Container>
      </AppBar>

      {/* Mobile Navigation Drawer */}
      <Drawer
        anchor="right"
        open={mobileDrawerOpen}
        onClose={toggleMobileDrawer}
        PaperProps={{
          sx: { width: { xs: '80%', sm: '60%', md: '40%' }, p: 2 }
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>Menu</Typography>
          <IconButton onClick={toggleMobileDrawer}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Divider sx={{ mb: 2 }} />
        <List>
          {mobileNavItems.map((item) => (
            <ListItem key={item.text} disablePadding>
              <ListItemButton 
                component={Link} 
                to={item.link}
                onClick={handleMobileMenuClick}
                sx={{ py: 1.5 }}
              >
                <ListItemText 
                  primary={item.text} 
                  primaryTypographyProps={{ 
                    fontWeight: 'medium',
                    fontSize: '1rem'
                  }} 
                />
              </ListItemButton>
            </ListItem>
          ))}
          
          {/* About submenu in mobile */}
          <ListItem disablePadding>
            <ListItemButton onClick={toggleMobileSubmenu} sx={{ py: 1.5 }}>
              <ListItemText 
                primary="About" 
                primaryTypographyProps={{ 
                  fontWeight: 'medium',
                  fontSize: '1rem'
                }} 
              />
            </ListItemButton>
          </ListItem>
          
          {mobileSubmenuOpen && (
            <Box sx={{ pl: 2 }}>
              {aboutSubmenuItems.map((item) => (
                <ListItem key={item.text} disablePadding>
                  <ListItemButton 
                    component={Link} 
                    to={item.link}
                    onClick={handleMobileMenuClick}
                    sx={{ py: 1.25 }}
                  >
                    <ListItemText 
                      primary={item.text} 
                      primaryTypographyProps={{ 
                        fontSize: '0.95rem'
                      }} 
                    />
                  </ListItemButton>
                </ListItem>
              ))}
            </Box>
          )}
        </List>
      </Drawer>
    </>
  );
};

export default Header;